export default __webpack_public_path__ + "static/media/crop.734ef3aa.svg";